import { CanDeactivateFn } from '@angular/router';

/** A screen that has to wrap up the running exam before the router may leave it. */
export interface ExamLeaveAware {
  canLeaveExam(): boolean;
}

/**
 * Any navigation off the exam screen that the screen didn't start itself
 * (browser back/forward, header/sidebar links, in-app URL changes) is
 * cancelled and replaced by the screen's own exit flow, so the attempt is
 * saved and can be resumed while its timer is still running.
 */
export const examLeaveGuard: CanDeactivateFn<ExamLeaveAware> = (component) =>
  component?.canLeaveExam ? component.canLeaveExam() : true;
